// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-yMgUOhL{--cols:1;grid-gap:var(--spacing-sm);display:grid;gap:var(--spacing-sm);grid-template-columns:repeat(1,1fr);grid-template-columns:repeat(var(--cols),1fr)}@media(min-width:667.98px){.-yMgUOhL{--cols:3}}@media(min-width:947.98px){.-yMgUOhL{--cols:3}}@media(min-width:1023.98px){.-yMgUOhL{--cols:4}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"grid": "-yMgUOhL"
};
module.exports = ___CSS_LOADER_EXPORT___;
